import { render, staticRenderFns } from "./AttendWorkerView.vue?vue&type=template&id=673dee64&scoped=true&"
import script from "./AttendWorkerView.vue?vue&type=script&lang=js&"
export * from "./AttendWorkerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673dee64",
  null
  
)

export default component.exports